import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";

/**
 * Basic Notfound: - We do not display notfound page, only redirecting to Home.
 * @returns Redirect to Home route
 */
export default function NotFound() {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/dashboard', { replace: true });
    }, [navigate]);

    return null;
}